import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_ENTERPRISE_PROFILE = 'GET_ENTERPRISE_PROFILE';
export const GET_ENTERPRISE_PROFILE_SUCCESS = 'GET_ENTERPRISE_PROFILE_SUCCESS';
export const GET_ENTERPRISE_PROFILE_FAILURE = 'GET_ENTERPRISE_PROFILE_FAILURE';

// Action Creators
export const getEnterpriseProfile = () => ({
  type: GET_ENTERPRISE_PROFILE,
});

export const getEnterpriseProfileSuccess = (data) => ({
  type: GET_ENTERPRISE_PROFILE_SUCCESS,
  payload: data,
});

export const getEnterpriseProfileFailure = (error) => ({
  type: GET_ENTERPRISE_PROFILE_FAILURE,
  payload: error,
});

// Thunk Function
export const getEnterpriseProfileCallAPI = (external) => {
  return async (dispatch) => {
    dispatch(getEnterpriseProfile());
    try {
      const response = await getMethodWithToken(url.enterpriseProfile);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getEnterpriseProfileSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(getEnterpriseProfileFailure(error?.message));
    }
  };
};
